import { ButtonType } from '../types'

type CalculateButtonType = (value: {
  isInProgressValidationValid: boolean
  isFinalValidationValid: boolean
  isTouched: boolean
  stepIsPrefilled: boolean
}) => ButtonType

/*
 * Calculates the button type of for the wizard stepper
 */
export const calculateButtonType: CalculateButtonType = ({ isInProgressValidationValid, isFinalValidationValid, isTouched, stepIsPrefilled }) => {
  if (!isInProgressValidationValid && isTouched) {
    return 'invalid'
  }

  if (isTouched && !isFinalValidationValid) {
    return 'incomplete'
  }

  if (stepIsPrefilled && !isFinalValidationValid) {
    return 'incomplete'
  }

  if (isFinalValidationValid) {
    return 'completed'
  }

  return 'inProgress'
}
